<div class="page-container" *ngIf="!loading && customer">
  <div class="detail-hero">
    <div class="hero-main">
      <button mat-icon-button routerLink="/wartung/kunden" matTooltip="Zurück zur Kundenliste" class="back-button">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div class="customer-identity">
        <div class="logo-stack">
          <div class="customer-avatar-lg" *ngIf="!customer.logoPath">{{getCustomerInitial(customer)}}</div>
          <div class="customer-logo-lg" *ngIf="customer.logoPath">
            <img [src]="getLogoUrl(customer.logoPath)" alt="Logo">
          </div>
          <div class="logo-upload-area">
            <button mat-icon-button matTooltip="Logo hochladen" (click)="logoInput.click()" class="logo-upload-btn">
              <mat-icon>photo_camera</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Logo entfernen" (click)="removeLogo()" *ngIf="customer.logoPath" class="logo-remove-btn">
              <mat-icon>close</mat-icon>
            </button>
            <input #logoInput type="file" hidden accept="image/png,image/jpeg,image/gif,image/svg+xml,image/webp" (change)="onLogoSelected($event)">
          </div>
        </div>

        <div class="identity-copy">
          <span class="eyebrow">Kundendetail</span>
          <h1>{{customer.name}}</h1>
          <div class="identity-meta">
            <span *ngIf="customer.address">
              <mat-icon class="meta-icon">location_on</mat-icon>
              {{customer.address}}
            </span>
            <span>
              <mat-icon class="meta-icon">electrical_services</mat-icon>
              {{equipments.length}} Anlage{{equipments.length === 1 ? '' : 'n'}}
            </span>
            <span>
              <mat-icon class="meta-icon">assignment</mat-icon>
              {{getOpenMaintenanceCount()}} offen
            </span>
          </div>
        </div>
      </div>

      <div class="hero-actions">
        <a mat-stroked-button *ngIf="customer.address" [href]="getMapLink(customer.address)" target="_blank" rel="noopener">
          <mat-icon>map</mat-icon>
          Route
        </a>
        <button mat-raised-button color="primary" (click)="editCustomer()">
          <mat-icon>edit</mat-icon>
          Bearbeiten
        </button>
      </div>
    </div>

    <aside class="contact-panel" [class.empty-contact]="!hasContactDetails(customer)">
      <div class="panel-heading">
        <div>
          <span class="eyebrow">Ansprechperson</span>
          <h2>{{customer.contactPersonName || 'Kein Kontakt hinterlegt'}}</h2>
        </div>
        <button mat-icon-button (click)="editCustomer()" matTooltip="Kontaktdaten bearbeiten">
          <mat-icon>edit</mat-icon>
        </button>
      </div>

      <div class="contact-grid" *ngIf="hasContactDetails(customer); else noContact">
        <a class="contact-tile" *ngIf="customer.contactPersonPhone" [href]="getTelLink(customer.contactPersonPhone)">
          <mat-icon>phone</mat-icon>
          <span>
            <small>Telefon</small>
            <strong>{{customer.contactPersonPhone}}</strong>
          </span>
        </a>

        <a class="contact-tile" *ngIf="customer.contactPersonEmail" [href]="getMailtoLink(customer.contactPersonEmail)">
          <mat-icon>email</mat-icon>
          <span>
            <small>E-Mail</small>
            <strong>{{customer.contactPersonEmail}}</strong>
          </span>
        </a>

        <div class="contact-tile muted" *ngIf="customer.contactPersonName">
          <mat-icon>badge</mat-icon>
          <span>
            <small>Name</small>
            <strong>{{customer.contactPersonName}}</strong>
          </span>
        </div>
      </div>

      <ng-template #noContact>
        <div class="empty-contact-message">
          <mat-icon>contact_mail</mat-icon>
          <span>Telefon oder E-Mail ergänzen, damit der Kunde direkt erreichbar ist.</span>
        </div>
      </ng-template>
    </aside>
  </div>

  <!-- Summary Stats -->
  <div class="summary-strip">
    <button type="button" class="summary-item" (click)="selectTab(0)">
      <mat-icon>electrical_services</mat-icon>
      <span class="summary-value">{{equipments.length}}</span>
      <span class="summary-label">Anlagen</span>
    </button>
    <button type="button" class="summary-item" (click)="selectTab(1)">
      <mat-icon>event_repeat</mat-icon>
      <span class="summary-value">{{plannedMaintenances.length}}</span>
      <span class="summary-label">Geplante Wartungen</span>
    </button>
    <button type="button" class="summary-item" (click)="selectTab(2)">
      <mat-icon>build</mat-icon>
      <span class="summary-value">{{serviceCallMaintenances.length}}</span>
      <span class="summary-label">Einsätze</span>
    </button>
    <button type="button" class="summary-item" (click)="selectTab(1)" [class.alert]="getOverdueMaintenanceCount() > 0">
      <mat-icon>{{getOverdueMaintenanceCount() > 0 ? 'warning' : 'task_alt'}}</mat-icon>
      <span class="summary-value">{{getOverdueMaintenanceCount() || getCompletionPercent() + '%'}}</span>
      <span class="summary-label">{{getOverdueMaintenanceCount() > 0 ? 'Überfällig' : 'Erledigt'}}</span>
    </button>
  </div>

  <!-- Tabs -->
  <mat-tab-group
    [selectedIndex]="activeTab"
    (selectedIndexChange)="onTabChanged($event)"
    (touchstart)="onTabTouchStart($event)"
    (touchend)="onTabTouchEnd($event)"
    (touchcancel)="onTabTouchCancel()"
    animationDuration="200ms"
    class="main-tabs">

    <!-- Tab 1: Anlagen / Verteiler -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">electrical_services</mat-icon>
        Anlagen & Verteiler
        <span class="tab-count" *ngIf="equipments.length">{{equipments.length}}</span>
      </ng-template>

      <div class="tab-content">
        <div class="tab-actions" *ngIf="canEdit && equipments.length > 0">
          <button mat-raised-button color="primary" (click)="addEquipment()">
            <mat-icon>add</mat-icon> Neuer Verteiler
          </button>
        </div>

        <div *ngIf="equipments.length === 0" class="empty-tab">
          <mat-icon>electrical_services</mat-icon>
          <p>Noch keine Anlagen/Verteiler angelegt.</p>
          <button mat-raised-button color="primary" *ngIf="canEdit" (click)="addEquipment()">
            <mat-icon>add</mat-icon> Ersten Verteiler anlegen
          </button>
        </div>

        <div class="equipment-grid" *ngIf="equipments.length > 0">
          <div class="equipment-card" *ngFor="let eq of equipments; trackBy: trackByEquipmentId">
            <div class="eq-header">
              <div class="eq-icon">
                <mat-icon>electrical_services</mat-icon>
              </div>
              <div class="eq-info">
                <h3>{{eq.name}}</h3>
                <span class="eq-location" *ngIf="eq.location">
                  <mat-icon class="meta-icon">place</mat-icon> {{eq.location}}
                </span>
              </div>
              <div class="eq-actions">
                <button mat-icon-button (click)="editEquipment(eq, $event)" matTooltip="Bearbeiten">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="deleteEquipment(eq, $event)" matTooltip="Löschen">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <div class="eq-stats">
              <span><strong>{{getMaintenanceCountForEquipment(eq)}}</strong> Wartungen</span>
              <span *ngIf="getLastMaintenanceDate(eq)">Letzte: {{getLastMaintenanceDate(eq) | date:'dd.MM.yyyy'}}</span>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Tab 2: Geplante Wartungen -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">event_repeat</mat-icon>
        Planmäßige Wartungen
        <span class="tab-count" *ngIf="plannedMaintenances.length">{{plannedMaintenances.length}}</span>
      </ng-template>

      <div class="tab-content">
        <div class="tab-actions" *ngIf="canEdit && plannedMaintenances.length > 0">
          <button mat-raised-button color="primary" (click)="addPlannedMaintenance()">
            <mat-icon>add</mat-icon> Wartung planen
          </button>
        </div>

        <div *ngIf="plannedMaintenances.length === 0" class="empty-tab">
          <mat-icon>event_repeat</mat-icon>
          <p>Noch keine planmäßigen Wartungen.</p>
          <button mat-raised-button color="primary" *ngIf="canEdit" (click)="addPlannedMaintenance()">
            <mat-icon>add</mat-icon> Wartung planen
          </button>
        </div>

        <div class="maintenance-list" *ngIf="plannedMaintenances.length > 0">
          <div class="m-card" *ngFor="let m of plannedMaintenances; trackBy: trackByMaintenanceId">
            <div class="m-date-col" (click)="openMaintenance(m)">
              <div class="m-date-badge" [class.overdue]="m.status === 'Overdue'">
                <span class="day">{{m.scheduledDate | date:'dd'}}</span>
                <span class="month">{{m.scheduledDate | date:'MMM yy'}}</span>
              </div>
            </div>
            <div class="m-info-col" (click)="openMaintenance(m)">
              <h4>{{m.title}}</h4>
              <div class="m-meta-row">
                <span class="m-equipment"><mat-icon class="meta-icon">electrical_services</mat-icon> {{m.equipment?.name ?? '–'}}</span>
                <span class="m-recurrence"><mat-icon class="meta-icon">repeat</mat-icon> {{getRecurrenceLabel(m.recurrenceType)}}</span>
                <span *ngIf="m.assignedUsers?.length" class="m-tech"><mat-icon class="meta-icon">group</mat-icon> {{getTechnicianNames(m)}}</span>
                <span *ngIf="!m.assignedUsers?.length && (m.assignedUser || m.assignedEmployee)" class="m-tech"><mat-icon class="meta-icon">person</mat-icon> {{m.assignedUser?.userName ?? m.assignedEmployee?.fullName}}</span>
              </div>
              <mat-progress-bar *ngIf="m.status === 'InProgress'" mode="determinate" [value]="m.progressPercent" class="m-progress"></mat-progress-bar>
            </div>
            <div class="m-status-col">
              <span class="status-chip" [ngClass]="getStatusClass(m.status)">{{getStatusLabel(m.status)}}</span>
              <button class="delete-btn" (click)="deleteMaintenance(m, $event)" title="Löschen">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Tab 3: Einsätze / Reparaturen -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">build</mat-icon>
        Einsätze & Reparaturen
        <span class="tab-count" *ngIf="serviceCallMaintenances.length">{{serviceCallMaintenances.length}}</span>
      </ng-template>

      <div class="tab-content">
        <div class="tab-actions" *ngIf="canEdit && serviceCallMaintenances.length > 0">
          <button mat-raised-button color="accent" (click)="addServiceCall()">
            <mat-icon>add</mat-icon> Neuer Einsatz
          </button>
        </div>

        <div *ngIf="serviceCallMaintenances.length === 0" class="empty-tab">
          <mat-icon>build</mat-icon>
          <p>Noch keine Einsätze oder Reparaturen dokumentiert.</p>
          <button mat-raised-button color="accent" *ngIf="canEdit" (click)="addServiceCall()">
            <mat-icon>add</mat-icon> Ersten Einsatz erfassen
          </button>
        </div>

        <div class="maintenance-list" *ngIf="serviceCallMaintenances.length > 0">
          <div class="m-card" *ngFor="let m of serviceCallMaintenances; trackBy: trackByMaintenanceId">
            <div class="m-date-col" (click)="openMaintenance(m)">
              <div class="m-date-badge service">
                <span class="day">{{m.scheduledDate | date:'dd'}}</span>
                <span class="month">{{m.scheduledDate | date:'MMM yy'}}</span>
              </div>
            </div>
            <div class="m-info-col" (click)="openMaintenance(m)">
              <h4>{{m.title}}</h4>
              <div class="m-meta-row">
                <span class="m-equipment"><mat-icon class="meta-icon">electrical_services</mat-icon> {{m.equipment?.name ?? '–'}}</span>
                <span *ngIf="m.assignedUsers?.length" class="m-tech"><mat-icon class="meta-icon">group</mat-icon> {{getTechnicianNames(m)}}</span>
                <span *ngIf="!m.assignedUsers?.length && (m.assignedUser || m.assignedEmployee)" class="m-tech"><mat-icon class="meta-icon">person</mat-icon> {{m.assignedUser?.userName ?? m.assignedEmployee?.fullName}}</span>
              </div>
              <div *ngIf="m.notes" class="m-description-line">
                <mat-icon class="meta-icon">notes</mat-icon>
                <span>{{m.notes}}</span>
              </div>
            </div>
            <div class="m-status-col">
              <span class="status-chip" [ngClass]="getStatusClass(m.status)">{{getStatusLabel(m.status)}}</span>
              <button class="delete-btn" (click)="deleteMaintenance(m, $event)" title="Löschen">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Tab 4: Material -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">inventory_2</mat-icon>
        Material/Regie
      </ng-template>

      <div class="tab-content">
        <div class="rate-section">
          <div class="section-heading-row">
            <div>
              <h3 class="section-subtitle">
                <mat-icon>euro</mat-icon> Regiestundensätze
              </h3>
              <p class="section-hint">Diese Sätze können beim Erstellen und Bearbeiten von Einsätzen ausgewählt werden.</p>
            </div>
          </div>

          <div class="rate-list" *ngIf="hourlyRates.length > 0">
            <div class="rate-row" *ngFor="let rate of hourlyRates; trackBy: trackByHourlyRateId">
              <div class="rate-main">
                <mat-icon>sell</mat-icon>
                <div>
                  <strong>{{rate.label}}</strong>
                  <span *ngIf="rate.isDefault" class="default-rate">Standard</span>
                </div>
              </div>
              <span class="rate-price">{{rate.hourlyRate | number:'1.2-2'}} €/h</span>
              <div class="rate-actions">
                <button mat-icon-button (click)="startEditHourlyRate(rate)" matTooltip="Stundensatz bearbeiten">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="deleteHourlyRate(rate)" matTooltip="Stundensatz löschen">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <div class="empty-rate-hint" *ngIf="hourlyRates.length === 0">
            <mat-icon>info</mat-icon>
            <span>Noch keine Stundensätze. Lege z.B. Monteur, Programmierer oder Projektleitung an.</span>
          </div>

          <div class="rate-form">
            <mat-form-field appearance="outline" class="rate-name-field">
              <mat-label>Bezeichnung</mat-label>
              <input matInput [(ngModel)]="newHourlyRate.label" placeholder="z.B. Monteur">
            </mat-form-field>
            <mat-form-field appearance="outline" class="rate-price-field">
              <mat-label>€/h</mat-label>
              <input matInput type="number" [(ngModel)]="newHourlyRate.hourlyRate" min="0" step="0.01">
            </mat-form-field>
            <mat-checkbox [(ngModel)]="newHourlyRate.isDefault" color="primary">Standard</mat-checkbox>
            <button mat-raised-button color="primary" (click)="saveHourlyRate()" [disabled]="!newHourlyRate.label?.trim()">
              <mat-icon>{{editingHourlyRateId ? 'save' : 'add'}}</mat-icon>
              {{editingHourlyRateId ? 'Speichern' : 'Hinzufügen'}}
            </button>
            <button mat-stroked-button *ngIf="editingHourlyRateId" (click)="cancelHourlyRateEdit()">
              Abbrechen
            </button>
          </div>
        </div>

        <div class="tab-actions">
          <button mat-raised-button color="primary" (click)="toggleMaterialForm()">
            <mat-icon>{{showMaterialForm ? 'close' : 'add'}}</mat-icon>
            {{showMaterialForm ? 'Abbrechen' : 'Material hinzufügen'}}
          </button>
        </div>

        <!-- Add Material Form -->
        <div class="material-form" *ngIf="showMaterialForm">
          <mat-form-field appearance="outline">
            <mat-label>Bezeichnung</mat-label>
            <input matInput [(ngModel)]="newMaterial.name" required>
          </mat-form-field>
          <mat-form-field appearance="outline" class="small-field">
            <mat-label>Menge</mat-label>
            <input matInput type="number" [(ngModel)]="newMaterial.quantity">
          </mat-form-field>
          <mat-form-field appearance="outline" class="small-field">
            <mat-label>Einheit</mat-label>
            <input matInput [(ngModel)]="newMaterial.unit">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Beschreibung</mat-label>
            <input matInput [(ngModel)]="newMaterial.description">
          </mat-form-field>
          <button mat-raised-button color="primary" (click)="saveMaterial()" [disabled]="!newMaterial.name?.trim() || addingMaterial">
            Speichern
          </button>
        </div>

        <div *ngIf="materials.length === 0 && !showMaterialForm" class="empty-tab">
          <mat-icon>inventory_2</mat-icon>
          <p>Keine Materialien hinterlegt.</p>
        </div>

        <div class="material-list" *ngIf="materials.length > 0">
          <div class="material-item" *ngFor="let mat of materials; trackBy: trackByCustomerMaterialId">
            <div class="mat-info">
              <mat-icon class="mat-item-icon">inventory_2</mat-icon>
              <div>
                <strong>{{mat.name}}</strong>
                <span class="mat-desc" *ngIf="mat.description"> – {{mat.description}}</span>
              </div>
            </div>
            <div class="mat-qty">{{mat.quantity}} {{mat.unit}}</div>
            <button mat-icon-button color="warn" (click)="deleteMaterial(mat)" matTooltip="Entfernen">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </div>

        <!-- Wartungs-Material (aufklappbar) -->
        <div class="wartung-material-section" *ngIf="maintenancesWithMaterials.length > 0">
          <h3 class="section-subtitle">
            <mat-icon>build</mat-icon> Material aus Wartungen & Einsätzen
          </h3>
          <mat-accordion>
            <mat-expansion-panel *ngFor="let m of maintenancesWithMaterials; trackBy: trackByMaintenanceId" class="wartung-mat-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="panel-type-icon">{{m.recurrenceType !== 'None' ? 'event_repeat' : 'build'}}</mat-icon>
                  {{m.title}}
                </mat-panel-title>
                <mat-panel-description>
                  {{m.materials.length}} Material{{m.materials.length !== 1 ? 'ien' : ''}}
                  <span class="panel-date">{{m.scheduledDate | date:'dd.MM.yyyy'}}</span>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="wartung-mat-list">
                <div class="wartung-mat-row" *ngFor="let mat of m.materials; trackBy: trackByMaintenanceMaterialId">
                  <div class="wartung-mat-info">
                    <mat-icon class="mat-item-icon small">inventory_2</mat-icon>
                    <span>{{mat.name}}</span>
                  </div>
                  <span class="wartung-mat-qty">{{mat.quantity}} {{mat.unit}}</span>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<!-- Loading -->
<div *ngIf="loading" class="loading-page">
  <mat-spinner diameter="48"></mat-spinner>
</div>
